import app from 'app';
import templateUrl from './submitClaimDownloadForm.html';
import './submitClaimDownloadForm.scss';

import { logEvent, eventCategories } from 'helpers/analytics';

import MEMBER_PORTAL from 'constants/memberPortal';

function SubmitClaimDownloadForm($state) {
  const SubmitClaimDownloadForm = this;

  SubmitClaimDownloadForm.$onInit = function() {
    logEvent('formOpened', {
      category: eventCategories.MSOON,
      planType: SubmitClaimDownloadForm.claimType
    });
    SubmitClaimDownloadForm.supportPhone = MEMBER_PORTAL.defaultSupportPhone;
    SubmitClaimDownloadForm.hasClaimFormLink = !!SubmitClaimDownloadForm.plan
      .claimFormLink;
  };

  SubmitClaimDownloadForm.goToInboxCompose = function() {
    $state.go('InboxCompose');
  };

  SubmitClaimDownloadForm.back = function() {
    SubmitClaimDownloadForm.page = '';
  };
}

app.component('submitClaimDownloadForm', {
  bindings: {
    claimType: '@',
    plan: '<',
    page: '=',
    showBack: '<'
  },
  controller: SubmitClaimDownloadForm,
  controllerAs: 'SubmitClaimDownloadForm',
  templateUrl
});

export default 'submitClaimDownloadForm';
